import React from 'react';
import { BaseDialog } from './BaseDialog.js';

export function DrazticImageDialog(data) {
    return (
        <BaseDialog thumbnail={data.thumbnail} title={data.title} text={data.text}>
            <img src={data.image} title={data.title} alt={data.text} />
        </BaseDialog>
    );
}
